import { CapabilityDomain, DOMAIN_COLORS } from '../types/persona_engine';

// Get Tailwind bg class for legacy named capability bars
export const getCapabilityColor = (capability: string): string => {
  const colorMap: Record<string, string> = {
    'creativity': 'bg-blue-600',
    'technical': 'bg-green-600',
    'analytical': 'bg-purple-600',
    'communication': 'bg-indigo-600',
    'reasoning': 'bg-yellow-600',
    'collaboration': 'bg-pink-600',
    'domain_expertise': 'bg-red-600',
    'adaptability': 'bg-orange-600',
    'leadership': 'bg-teal-600',
    'research': 'bg-cyan-600'
  };
  
  return colorMap[capability.toLowerCase()] || 'bg-gray-600';
};

/**
 * Returns the hex color for a CapabilityDomain.
 * Falls back to gray if the domain is unrecognised.
 */
export const getDomainColor = (domain: CapabilityDomain | string): string => {
  return (DOMAIN_COLORS as Record<string, string>)[domain] ?? '#6b7280';
};
